var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "520" },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title-text-custom" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("ThirdPartyTermsOfService")) + "\n    "
            )
          ]),
          _vm._v(" "),
          _c("v-card-text", [
            _c(
              "div",
              {
                staticClass: "d-flex pa-4",
                staticStyle: { "margin-left": "-15px", "margin-top": "-20px" }
              },
              [
                _c("InputField", {
                  attrs: {
                    inputType: "checkbox",
                    value: _vm.term1,
                    "checkbox-options": _vm.agreeThirdPartyConsumableCheckbox,
                    height: 15,
                    width: 15,
                    border: "1px solid",
                    size: "100",
                    inputStyle: _vm.inputStyle,
                    checkboxLabelStyle: _vm.checkboxLabelStyle
                  },
                  on: {
                    input: function($event) {
                      _vm.term1 = !_vm.term1
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex pa-4",
                staticStyle: { "margin-left": "-15px", "margin-bottom": "30px" }
              },
              [
                _c("InputField", {
                  attrs: {
                    inputType: "checkbox",
                    value: _vm.term2,
                    "checkbox-options": _vm.agreeToServiceTermsCheckbox,
                    height: 15,
                    width: 15,
                    border: "1px solid",
                    size: "100",
                    inputStyle: _vm.inputStyle,
                    checkboxLabelStyle: _vm.checkboxLabelStyleTerm2
                  },
                  on: {
                    input: function($event) {
                      _vm.term2 = !_vm.term2
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  "button-color": "#FFF",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStyling
                },
                on: {
                  buttonClick: function($event) {
                    _vm.clearTerms()
                    _vm.$emit("cancelMap")
                  }
                }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Add"),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  "button-styling": _vm.actionButtonsStylingSave,
                  disabled: !_vm.term1 || !_vm.term2
                },
                on: {
                  buttonClick: function($event) {
                    _vm.clearTerms()
                    _vm.$emit("createMap")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b75f6c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b75f6c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Maps/ThirdPartyDialog.vue
// module id = null
// module chunks = 